function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1948(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.63,
    height: 7.28,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 3.64
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7.28,
    width: 18.63,
    height: 17.77,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 16.165
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25.05,
    width: 18.63,
    height: 19.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6614285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 34.905
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 44.77,
    width: 18.63,
    height: 22.67,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6614285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 56.105000000000004
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 67.43,
    width: 18.63,
    height: 23.04,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 78.95
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 90.47,
    width: 18.63,
    height: 23.54,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 102.24
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.02,
    width: 18.63,
    height: 29.38,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 128.71
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 143.4,
    width: 18.63,
    height: 29.63,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.6575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 158.215
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 173.04,
    width: 18.63,
    height: 31.64,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.32875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 188.85999999999999
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 204.68,
    width: 18.63,
    height: 32.21,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 220.785
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 236.89,
    width: 18.63,
    height: 32.27,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6614285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 253.02499999999998
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 269.16,
    width: 18.63,
    height: 33.97,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 286.14500000000004
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 303.13,
    width: 18.63,
    height: 35.66,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.32875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 320.96
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 338.79,
    width: 18.63,
    height: 36.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6614285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 357.25
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 375.71,
    width: 18.63,
    height: 37.55,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.726
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 394.48499999999996
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 413.26,
    width: 18.63,
    height: 37.61,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.863
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 432.065
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 450.87,
    width: 18.63,
    height: 39.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 470.43
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 489.98,
    width: 18.63,
    height: 39.56,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.726
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 509.76
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 529.54,
    width: 18.63,
    height: 40.94,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.726
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 550.01
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 570.47,
    width: 18.63,
    height: 42.25,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.32875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 591.595
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 612.73,
    width: 18.63,
    height: 42.69,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 634.075
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 655.42,
    width: 18.63,
    height: 44.58,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.32875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.315,
    y: 677.7099999999999
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 0,
    width: 26.61,
    height: 32.05,
    style: {
      fill: "#007F00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.801428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.935,
    y: 16.025
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.24,
    y: 0,
    width: 26.98,
    height: 32.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8542857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.730000000000004,
    y: 16.025
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.22,
    y: 0,
    width: 27.96,
    height: 32.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.495
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.2,
    y: 16.025
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.18,
    y: 0,
    width: 28.18,
    height: 32.05,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.025714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.27000000000001,
    y: 16.025
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.36,
    y: 0,
    width: 28.98,
    height: 32.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 142.85000000000002,
    y: 16.025
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.34,
    y: 0,
    width: 29.2,
    height: 32.05,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.94,
    y: 16.025
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.55,
    y: 0,
    width: 29.64,
    height: 32.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.94
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.37,
    y: 16.025
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.19,
    y: 0,
    width: 29.71,
    height: 32.05,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.951666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.045,
    y: 16.025
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 0,
    width: 29.75,
    height: 32.05,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.958333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.775,
    y: 16.025
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.65,
    y: 0,
    width: 30.08,
    height: 32.05,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.69,
    y: 16.025
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.73,
    y: 0,
    width: 30.59,
    height: 32.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.82375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.02500000000003,
    y: 16.025
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.32,
    y: 0,
    width: 31.17,
    height: 32.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.905,
    y: 16.025
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.49,
    y: 0,
    width: 31.43,
    height: 32.05,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.205,
    y: 16.025
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.92,
    y: 0,
    width: 31.58,
    height: 32.05,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.263333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.71000000000004,
    y: 16.025
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430.5,
    y: 0,
    width: 31.76,
    height: 32.05,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.38,
    y: 16.025
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.26,
    y: 0,
    width: 32.31,
    height: 32.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.578571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 478.41499999999996,
    y: 16.025
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.56,
    y: 0,
    width: 32.82,
    height: 32.05,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.00625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.97,
    y: 16.025
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.38,
    y: 0,
    width: 33.04,
    height: 32.05,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2049999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.9,
    y: 16.025
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.41,
    y: 0,
    width: 34.13,
    height: 32.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.341666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.475,
    y: 16.025
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.54,
    y: 0,
    width: 34.71,
    height: 32.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.578571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.895,
    y: 16.025
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 629.26,
    y: 0,
    width: 35.37,
    height: 32.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.578571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.9449999999999,
    y: 16.025
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 664.63,
    y: 0,
    width: 35.37,
    height: 32.05,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.409999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 682.3149999999999,
    y: 16.025
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 32.05,
    width: 35.2,
    height: 32.24,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.03
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 48.17
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 64.29,
    width: 35.2,
    height: 33.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.781428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 81.025
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 97.76,
    width: 35.2,
    height: 35.23,
    style: {
      fill: "#007F00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 115.375
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 133,
    width: 35.2,
    height: 36.07,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.866666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 151.035
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 169.06,
    width: 35.2,
    height: 36.53,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9111111111111114
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 187.325
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 205.59,
    width: 35.2,
    height: 36.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.866666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 223.89000000000001
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 242.19,
    width: 35.2,
    height: 37.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.040000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 260.705
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 279.22,
    width: 35.2,
    height: 37.06,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.866666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 297.75
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 316.28,
    width: 35.2,
    height: 37.16,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5200000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 334.85999999999996
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 353.44,
    width: 35.2,
    height: 37.23,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 372.055
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 390.67,
    width: 35.2,
    height: 37.46,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.028571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 409.40000000000003
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 428.13,
    width: 35.2,
    height: 37.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.866666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 447.025
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 465.93,
    width: 35.2,
    height: 37.99,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.866666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 484.925
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 503.92,
    width: 35.2,
    height: 38.03,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.028571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 522.9350000000001
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 541.95,
    width: 35.2,
    height: 38.82,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.040000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 561.36
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 580.77,
    width: 35.2,
    height: 39.29,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.040000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 600.415
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 620.06,
    width: 35.2,
    height: 39.65,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.040000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 639.885
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.63,
    y: 659.71,
    width: 35.2,
    height: 40.29,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.028571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.230000000000004,
    y: 679.855
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 32.05,
    width: 36.24,
    height: 39.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.95,
    y: 51.61
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.07,
    y: 32.05,
    width: 36.93,
    height: 39.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.386
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.535,
    y: 51.61
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 32.05,
    width: 37.56,
    height: 39.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.365714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 145.78,
    y: 51.61
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.56,
    y: 32.05,
    width: 37.95,
    height: 39.12,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.590000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.535,
    y: 51.61
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.51,
    y: 32.05,
    width: 38.67,
    height: 39.12,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.296666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.845,
    y: 51.61
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.18,
    y: 32.05,
    width: 39.56,
    height: 39.12,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.96000000000004,
    y: 51.61
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.74,
    y: 32.05,
    width: 39.74,
    height: 39.12,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.61,
    y: 51.61
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.48,
    y: 32.05,
    width: 40.46,
    height: 39.12,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.824
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.71000000000004,
    y: 51.61
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.95,
    y: 32.05,
    width: 40.52,
    height: 39.12,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.824
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.21,
    y: 51.61
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.47,
    y: 32.05,
    width: 41.24,
    height: 39.12,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.912
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 422.09000000000003,
    y: 51.61
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.7,
    y: 32.05,
    width: 41.93,
    height: 39.12,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.824
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.66499999999996,
    y: 51.61
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.63,
    y: 32.05,
    width: 42.05,
    height: 39.12,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.655,
    y: 51.61
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 526.67,
    y: 32.05,
    width: 42.46,
    height: 39.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.9,
    y: 51.61
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.14,
    y: 32.05,
    width: 43.03,
    height: 39.12,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.588571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 590.655,
    y: 51.61
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 612.17,
    y: 32.05,
    width: 43.54,
    height: 39.12,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 633.9399999999999,
    y: 51.61
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 655.71,
    y: 32.05,
    width: 44.29,
    height: 39.12,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 677.855,
    y: 51.61
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 71.17,
    width: 44.33,
    height: 39.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.545000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 90.805
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 110.44,
    width: 44.33,
    height: 39.48,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.895999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 130.18
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 149.92,
    width: 44.33,
    height: 39.58,
    style: {
      fill: "#006600"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 169.70999999999998
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 189.5,
    width: 44.33,
    height: 39.69,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.938
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 209.345
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 229.19,
    width: 44.33,
    height: 39.93,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.704285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 249.155
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 269.12,
    width: 44.33,
    height: 39.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.658333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 289.095
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 309.07,
    width: 44.33,
    height: 40.38,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 329.26
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 349.44,
    width: 44.33,
    height: 40.59,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.798571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 369.735
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 390.03,
    width: 44.33,
    height: 41.54,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 410.79999999999995
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 431.57,
    width: 44.33,
    height: 41.96,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.993333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 452.55
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 473.53,
    width: 44.33,
    height: 44.25,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 495.655
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 517.78,
    width: 44.33,
    height: 44.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.433
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 540.12
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 562.46,
    width: 44.33,
    height: 45.28,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9255555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 585.1
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 607.74,
    width: 44.33,
    height: 46.02,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.388333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 630.75
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 653.77,
    width: 44.33,
    height: 46.23,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.866
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.995,
    y: 676.885
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.16,
    y: 71.17,
    width: 44.65,
    height: 46.08,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.485,
    y: 94.21000000000001
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.81,
    y: 71.17,
    width: 46.86,
    height: 46.08,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.216
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.24,
    y: 94.21000000000001
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.68,
    y: 71.17,
    width: 47.32,
    height: 46.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.34,
    y: 94.21000000000001
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.99,
    y: 71.17,
    width: 48.13,
    height: 46.08,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.055,
    y: 94.21000000000001
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.12,
    y: 71.17,
    width: 50.09,
    height: 46.08,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.216
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.165,
    y: 94.21000000000001
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.21,
    y: 71.17,
    width: 51.18,
    height: 46.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.79999999999995,
    y: 94.21000000000001
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.39,
    y: 71.17,
    width: 51.43,
    height: 46.08,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.10499999999996,
    y: 94.21000000000001
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 437.82,
    y: 71.17,
    width: 52.12,
    height: 46.08,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.88,
    y: 94.21000000000001
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.93,
    y: 71.17,
    width: 52.42,
    height: 46.08,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.14,
    y: 94.21000000000001
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.36,
    y: 71.17,
    width: 52.47,
    height: 46.08,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.595,
    y: 94.21000000000001
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.83,
    y: 71.17,
    width: 52.57,
    height: 46.08,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.12
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 621.115,
    y: 94.21000000000001
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 647.4,
    y: 71.17,
    width: 52.6,
    height: 46.08,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.582857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.6999999999999,
    y: 94.21000000000001
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.16,
    y: 117.25,
    width: 49.28,
    height: 49.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.8,
    y: 142.12
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.16,
    y: 166.99,
    width: 49.28,
    height: 50.4,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.213333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.8,
    y: 192.19
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.16,
    y: 217.39,
    width: 49.28,
    height: 50.49,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.8,
    y: 242.635
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.16,
    y: 267.88,
    width: 49.28,
    height: 50.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.213333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.8,
    y: 293.33
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.16,
    y: 318.78,
    width: 49.28,
    height: 51.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.8,
    y: 344.335
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.16,
    y: 369.9,
    width: 49.28,
    height: 51.75,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.8,
    y: 395.775
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.16,
    y: 421.65,
    width: 49.28,
    height: 52.75,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.8,
    y: 448.025
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.16,
    y: 474.4,
    width: 49.28,
    height: 53.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.8,
    y: 501.37
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.16,
    y: 528.34,
    width: 49.28,
    height: 56.93,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.8,
    y: 556.8050000000001
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.16,
    y: 585.26,
    width: 49.28,
    height: 57.19,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.928
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.8,
    y: 613.855
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.16,
    y: 642.45,
    width: 49.28,
    height: 57.55,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.213333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.8,
    y: 671.225
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.44,
    y: 117.25,
    width: 50.35,
    height: 57.46,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.615,
    y: 145.98
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.79,
    y: 117.25,
    width: 50.9,
    height: 57.46,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.23999999999998,
    y: 145.98
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.68,
    y: 117.25,
    width: 51.71,
    height: 57.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.618333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.535,
    y: 145.98
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.4,
    y: 117.25,
    width: 53.93,
    height: 57.46,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.988333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.36499999999995,
    y: 145.98
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.33,
    y: 117.25,
    width: 54.2,
    height: 57.46,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.742857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.43,
    y: 145.98
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.52,
    y: 117.25,
    width: 55.42,
    height: 57.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.917142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.22999999999996,
    y: 145.98
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.94,
    y: 117.25,
    width: 56.56,
    height: 57.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.312000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.22,
    y: 145.98
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 520.5,
    y: 117.25,
    width: 58.45,
    height: 57.46,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.576666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.725,
    y: 145.98
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 578.95,
    y: 117.25,
    width: 60.12,
    height: 57.46,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.208571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.01,
    y: 145.98
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 639.07,
    y: 117.25,
    width: 60.93,
    height: 57.46,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.492
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.5350000000001,
    y: 145.98
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.44,
    y: 174.72,
    width: 60.76,
    height: 59.07,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.845
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.82,
    y: 204.255
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.44,
    y: 233.79,
    width: 60.76,
    height: 61.74,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.82,
    y: 264.65999999999997
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.44,
    y: 295.53,
    width: 60.76,
    height: 63.46,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.82,
    y: 327.26
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.44,
    y: 358.99,
    width: 60.76,
    height: 64.42,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.82,
    y: 391.2
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.44,
    y: 423.41,
    width: 60.76,
    height: 66.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.82,
    y: 456.76500000000004
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.44,
    y: 490.12,
    width: 60.76,
    height: 68.6,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.82,
    y: 524.42
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.44,
    y: 558.72,
    width: 60.76,
    height: 70.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.82,
    y: 594.02
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.44,
    y: 629.32,
    width: 60.76,
    height: 70.68,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.82,
    y: 664.6600000000001
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 174.72,
    width: 66.98,
    height: 64.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.69,
    y: 207.085
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.19,
    y: 174.72,
    width: 67.36,
    height: 64.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.09125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.87,
    y: 207.085
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.55,
    y: 174.72,
    width: 68.75,
    height: 64.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.247142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.925,
    y: 207.085
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.3,
    y: 174.72,
    width: 70.87,
    height: 64.73,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.192222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.735,
    y: 207.085
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 482.17,
    y: 174.72,
    width: 71.39,
    height: 64.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.192222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 517.865,
    y: 207.085
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.56,
    y: 174.72,
    width: 71.54,
    height: 64.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.247142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 589.3299999999999,
    y: 207.085
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.1,
    y: 174.72,
    width: 74.9,
    height: 64.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.788333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.5500000000001,
    y: 207.085
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 239.45,
    width: 68.52,
    height: 71.01,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.45999999999998,
    y: 274.955
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 310.45,
    width: 68.52,
    height: 73.7,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.45999999999998,
    y: 347.3
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 384.15,
    width: 68.52,
    height: 78.19,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.703999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.45999999999998,
    y: 423.245
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 462.35,
    width: 68.52,
    height: 78.98,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.45999999999998,
    y: 501.84000000000003
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 541.33,
    width: 68.52,
    height: 79.29,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.45999999999998,
    y: 580.975
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 620.61,
    width: 68.52,
    height: 79.39,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.45999999999998,
    y: 660.3050000000001
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.73,
    y: 239.45,
    width: 75.17,
    height: 75.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.528333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.315,
    y: 277.34499999999997
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.9,
    y: 239.45,
    width: 75.55,
    height: 75.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.591666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 389.67499999999995,
    y: 277.34499999999997
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.45,
    y: 239.45,
    width: 79.78,
    height: 75.79,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.158000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.34,
    y: 277.34499999999997
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.23,
    y: 239.45,
    width: 83.21,
    height: 75.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.421111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 548.835,
    y: 277.34499999999997
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 590.44,
    y: 239.45,
    width: 109.56,
    height: 75.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.9475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 645.22,
    y: 277.34499999999997
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.73,
    y: 315.24,
    width: 93.22,
    height: 95.51,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.644
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.34000000000003,
    y: 362.995
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.73,
    y: 410.75,
    width: 93.22,
    height: 128.04,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.34000000000003,
    y: 474.77
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.73,
    y: 538.79,
    width: 93.22,
    height: 161.21,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.34000000000003,
    y: 619.395
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.95,
    y: 315.24,
    width: 138.29,
    height: 119.09,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 29.7725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 439.09499999999997,
    y: 374.785
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.24,
    y: 315.24,
    width: 191.76,
    height: 119.09,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.848333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.12,
    y: 374.785
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.95,
    y: 434.33,
    width: 105.23,
    height: 265.67,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.032857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 422.565,
    y: 567.165
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.18,
    y: 434.33,
    width: 224.82,
    height: 265.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 37.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.59,
    y: 567.165
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1948);
export default __webpack_public_path__ + "static/media/1948.470326943ade71b72c96b4d21a270e74.svg";
export { ForwardRef as ReactComponent };